import http from "../http";

/**
 * @typedef {Object} ConversationFilters
 * @property {string} filter - Filter type (e.g., 'read', 'unread')
 * @property {number} page - Page number
 * @property {number} per_page - Items per page
 */

/**
 * Fetch conversations with specified filters
 * @param {ConversationFilters} filters
 * @returns {Promise<any>}
 */
export function getConversations(filters = {}) {
  return http.get("/buyer/conversation", {
    params: {
      filter: filters.filter,
      page: filters.page,
      per_page: filters.per_page,
    },
  });
}

/**
 * Get conversation count
 * @returns {Promise} API response
 */
export function getConversationCount() {
  return http.get("/buyer/conversation/count");
}

/**
 * Fetch conversation details
 * @param {string} conversationId - Conversation ID
 * @param {Object} params - Pagination parameters
 * @param {number} params.page - Page number
 * @param {number} params.per_page - Items per page
 * @returns {Promise<any>}
 */
export function getConversationDetail(conversationId, params = {}) {
  if (!conversationId) {
    throw new Error("Conversation ID is required");
  }

  return http.get(`/buyer/conversation/${conversationId}`, {
    params: {
      page: params.page,
      per_page: params.per_page,
    },
  });
}

/**
 * Fetch conversation user details
 * @param {string} conversationId - Conversation ID
 * @returns {Promise<any>}
 */
export function getConversationUser(conversationId) {
  if (!conversationId) {
    throw new Error("Conversation ID is required");
  }

  return http.get(`/buyer/conversation/user/${conversationId}`);
}

/**
 * Create a new conversation
 * @param {Object} data - Conversation data
 * @returns {Promise<any>}
 */
export function createConversation(data) {
  return http.post("/buyer/conversation/create", data);
}

/**
 * Send a message in a conversation
 * @param {string} conversationId - Conversation ID
 * @param {Object} message - Message data
 * @returns {Promise<any>}
 */
export function sendMessage(conversationId, message) {
  if (!conversationId) {
    throw new Error("Conversation ID is required");
  }

  return http.post(`/buyer/conversation/send/${conversationId}`, message);
}

/**
 * Delete a conversation
 * @param {string} conversationId - Conversation ID
 * @returns {Promise<any>}
 */
export function deleteConversation(conversationId) {
  if (!conversationId) {
    throw new Error("Conversation ID is required");
  }

  return http.delete(`/buyer/conversation/delete/${conversationId}`);
}
